"use client"

import MaxWidthContainer from './max-width-container'
import CustomLabel from '../ui/custom-label'
import { api } from '@/trpc/react'
import { Skeleton } from '../ui/skeleton'
import SpecialCategoryCard from './special-category-card'

export default function SpecialCategories() {
    const { data, isLoading } = api.trip_category.get_categories.useQuery()

    if (isLoading) return (
        <section className='py-8 md:py-12'>
            <MaxWidthContainer className='space-y-5'>
                <CustomLabel label='Trending Categories' />
                <div className='grid sm:grid-cols-2 lg:grid-cols-3 gap-6 xl:gap-8'>
                    {
                        Array.from({ length: 6 }).map((load, _index) => (
                            <Skeleton key={_index} className='h-64 lg:h-56 xl:h-[17rem] bg-gray-400 rounded-lg' />
                        ))
                    }
                </div>
            </MaxWidthContainer>
        </section>
    )

    if (!data || data.length < 1) return null

    return (
        <section className='py-8 md:py-12'>
            <MaxWidthContainer className='space-y-5'>
                <CustomLabel label='Trending Categories' />
                <div className='grid sm:grid-cols-2 lg:grid-cols-3 gap-4  xl:gap-6'>
                    {
                        data.map((splCat) => (
                            <SpecialCategoryCard
                                key={splCat.slug}
                                data={splCat}
                            />
                        ))
                    }
                </div>
            </MaxWidthContainer>
        </section>
    )
}